/* global axios */

import ApiClient from './ApiClient';

class TeamPauseTemplates extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  get(teamId) {
    return axios.get(`${this.baseUrl()}/teams/${teamId}/pause_templates`);
  }

  update(teamId, pauseTemplateIds) {
    return axios.patch(`${this.baseUrl()}/teams/${teamId}/pause_templates`, {
      pause_template_ids: pauseTemplateIds,
    });
  }
}

export default new TeamPauseTemplates();
